import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserRideMechanicGameProps {
    onComplete: () => void;
}

interface PhaserRideMechanicGameState {
}

const gameConfig: GameConfig = {
    title: "Ride Mechanic Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserRideMechanicGame extends React.Component<PhaserRideMechanicGameProps, PhaserRideMechanicGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserRideMechanicGameProps) {
        super(props);
        bindAllOfThis(this, PhaserRideMechanicGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserRideMechanicGame;



// WEBPACK FOOTER //
// ./src/games/RideMechanicGame/Main.tsx